import { useAuthContext } from "../contexts/AuthContext";

/**
 * useAuth
 *
 * Purpose: Convenience wrapper around AuthContext.
 * Used by: Components and pages that need authentication state.
 */
export const useAuth = () => useAuthContext();

export default useAuth;
